export default __webpack_public_path__ + "static/media/coinlogo.c988307f.svg";